import { t } from "@/i18n-js/instance";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";

const i18nRoot = "pricing_plans.upgrade_modal.block_enterprise_downgrade";
export const BlockEnterpriseDowngrade = () => {
  const { currentPeriodEnd } = usePlanStatus();
  const date = currentPeriodEnd
    ? new Date(currentPeriodEnd).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : "";

  const handleContactSupportOnClick = () => {
    window.open("mailto:support@circle.so", "emailWindow");
  };
  return (
    <>
      <Modal.Header>
        <Modal.Title>{t([i18nRoot, "title"])}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Typography.BodyMd>
          <div className="flex flex-col items-center gap-2">
            <Typography.BodyMd>
              {t([i18nRoot, "your_current_plan"])}

              <span className="font-bold">{date}</span>
            </Typography.BodyMd>
            <Typography.BodyMd>
              {t([i18nRoot, "for_questions"])}
            </Typography.BodyMd>
          </div>
        </Typography.BodyMd>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex flex-row justify-end">
          <Button variant="primary" onClick={handleContactSupportOnClick}>
            {t([i18nRoot, "button"])}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};
